const kebabCase = require('lodash/kebabCase')
const toLower = require('lodash/toLower')
const pipe = require('./pipe')

module.exports = function toSlug (value) {
  return pipe(value)(
    toLower,
    encodeURI
  )
}
